import { useEffect, useRef } from 'react';

// Elemanı görünüme girince .revealed sınıfı ekler (bir kez).
export default function useScrollReveal({ threshold = 0.12, rootMargin = '0px 0px -8% 0px' } = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      el.classList.add('revealed');
      return undefined;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold, rootMargin }
    );
    // el'in kendisi .reveal ise onu, değilse içindeki .reveal öğelerini izle
    const targets = el.classList.contains('reveal') ? [el] : el.querySelectorAll('.reveal');
    targets.forEach((c) => io.observe(c));
    return () => io.disconnect();
  }, [threshold, rootMargin]);

  return ref;
}
